import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { ThemePalette } from "@angular/material/core";
import { MatCheckbox } from "@angular/material/checkbox";

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.component.html",
  imports: [ReactiveFormsModule, MatCheckbox],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxComponent implements OnInit {
  id = input<string | undefined>();
  parentForm = input.required<FormGroup<any>>();
  formControlKey = input.required<string>();
  text = input<string>();
  checked = input<boolean>(false);
  name = input<string | undefined>();
  inline = input<boolean>(false);
  rounded = input<boolean>(false);
  size = input<"xl" | "md" | "sm" | undefined>();
  color = input<ThemePalette | undefined>();

  constructor() {}

  ngOnInit() {}
}
